import { FC } from 'react';
import UserDocumentRequestCard from '@components/UserDocumentRequestCard';
import s from './UserDocumentRequests.module.scss';

type Props = {
  requests: Array<Parameters<typeof UserDocumentRequestCard>[0]['request']>;
};

const UserDocumentRequests: FC<Props> = ({ requests }) => (
  <div className={s.wrapper}>
    {requests.map(request => (
      <UserDocumentRequestCard key={request.id} request={request} canClick/>
    ))}
  </div>
);

export default UserDocumentRequests;
